export function validateBoolean(value) {
    if (typeof value === 'string' || value instanceof String) {
        return value !== "false";
    } else {
        return !!value;
    }
}